var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Component } from 'react';
import { ReactReduxContext } from 'react-redux';
import { replaceReducersAndSagas } from '../../utils/replace-reducers-and-sagas';
import { getIsClient } from '../../utils';
import { runInjectorConfig } from './utils/run-injector-config';
var ReduxStoreLoader = /** @class */ (function (_super) {
    __extends(ReduxStoreLoader, _super);
    function ReduxStoreLoader(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.contextStore = context.store;
        // link to store in state because of getting "this.context" in getDerivedStateFromProps
        _this.state = {
            reduxStore: context.store,
            ableToReplace: getIsClient(), // need not to replace on server side
        };
        return _this;
    }
    ReduxStoreLoader.getDerivedStateFromProps = function (props, state) {
        var _a, _b;
        var isNode = !getIsClient();
        // if SSR and initial load we dont want to replace any of reducers and sagas
        // moreover - if this is NodeJs render phase - we need to inject reducers and sagas and fetch data BEFORE to render JSX
        // because of performance
        if (isNode) {
            return { ableToReplace: false };
        }
        if (!state.ableToReplace) {
            return { ableToReplace: true };
        }
        if (!props.withoutRemovingReducers) {
            replaceReducersAndSagas({
                fromState: props.fromState,
                toState: props.toState,
                store: state.reduxStore,
                reducersNotToReplace: (_a = props === null || props === void 0 ? void 0 : props.storeInjectConfig) === null || _a === void 0 ? void 0 : _a.reducersNotToReplace,
                sagasNotToReplace: (_b = props === null || props === void 0 ? void 0 : props.storeInjectConfig) === null || _b === void 0 ? void 0 : _b.sagasNotToReplace,
            });
        }
        return {};
    };
    ReduxStoreLoader.prototype.componentDidMount = function () {
        runInjectorConfig(__assign(__assign({}, this.props), { store: this.state.reduxStore }));
    };
    ReduxStoreLoader.prototype.componentDidUpdate = function () {
        runInjectorConfig(__assign(__assign({}, this.props), { store: this.state.reduxStore }));
    };
    ReduxStoreLoader.prototype.render = function () {
        return this.props.children;
    };
    // eslint-disable-next-line
    ReduxStoreLoader.contextType = ReactReduxContext;
    return ReduxStoreLoader;
}(Component));
export { ReduxStoreLoader };
